import { render, staticRenderFns } from "./number-of-symbols.vue?vue&type=template&id=3b6c127a&scoped=true&"
import script from "./number-of-symbols.vue?vue&type=script&lang=js&"
export * from "./number-of-symbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c127a",
  null
  
)

export default component.exports